import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActiveTypeEnum } from '../../../core/enums/master.enum';

@Component({
  selector: 'app-create-edit-modal',
  templateUrl: './create-edit-modal.component.html',
  styleUrls: ['./create-edit-modal.component.scss']
})
export class CreateEditModalComponent implements OnInit {

  constructor(
    public activeModal: NgbActiveModal,
  ) { }

  @Input() public title: string = "";
  @Input() public titleName: string = "";
  @Input() public itemId: number;
  @Input() public name: string = "";
  @Input() public status: boolean = true;
  @Input() public callback: Function
  @Output() res = new EventEmitter<boolean>();

  @Input() public titleName2: string = "";
  @Input() public code: string = "";

  @Input() public titleCountUnit: string ="";
  @Input() public countUnit: string;


  activeTypeStatus = ActiveTypeEnum;
  requiredName: boolean = false;
  requiredCode: boolean = false;

  ngOnInit(): void {
  }

  closeModal() {
    this.activeModal.close();
  }

  onSave() {
    if (this.name) {
      this.requiredName = false;
      if (this.itemId) {
        this.callback({ id: this.itemId, name: this.name, status: this.status, code: this.code, countUnit: this.countUnit});
      }
      else {
        this.callback({ name: this.name, status: this.status, code: this.code, countUnit: this.countUnit });
      }
    }
    else {
      this.requiredName = true;
    }
  }
}
